import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const SelectWrapper = styled.div`
    position: relative;
`;

export const ActionSelect = styled.div(
    ({ theme: { boxShadow, palette, radius } }) => css`
        background-color: ${palette.neutral.white};
        border-radius: ${radius[6]}px;
        min-width: 266px;
        padding: 10px 0;
        position: absolute;
        top: calc(100% + 16px);
        right: -24px;
        z-index: 9;
        box-shadow: ${boxShadow.big};
    `,
);

export const SelectLink = styled(Link)`
    text-decoration: none;
`;

export const SelectItem = styled.div(
    ({ theme: { palette } }) => css`
        align-items: center;
        cursor: pointer;
        display: flex;
        gap: 8px;
        padding: 6px 24px;

        &:hover {
            background-color: ${palette.tertiary.background};
        }
    `,
);
